import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Group from 'components/utils/Group'
import OfferPagePackageInclusionsList from '../OfferPagePackageInclusionsList'
import LoyaltyInclusions from 'loyalty/components/LoyaltyInclusions'
import FlashHotelReturnFlightsInclusion from './FlashHotelReturnFlightsInclusion'
import type { SvgIconProps } from 'LuxKit/SvgIcon'

interface Props {
  inclusions: Array<App.PackageInclusion>
  bonusInclusions: Array<App.PackageInclusion>
  size?: 'small' | 'medium' | 'large'
  offer?: App.HotelOffer | App.VillaOffer
  showReturnFlightsInclusion?: boolean
  rooms?: Array<App.Occupants>
  iconSize?: SvgIconProps['size']
}

function InclusionsSection(props: Props) {
  const { inclusions, bonusInclusions, size = 'medium', offer, showReturnFlightsInclusion, rooms, iconSize } = props

  return <VerticalSpacer gap={12}>
    {!!bonusInclusions.length && <OfferPagePackageInclusionsList variant="bonus">
      {bonusInclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} size={size} iconSize={iconSize} />)}
    </OfferPagePackageInclusionsList>}
    <Group direction="vertical" gap={4}>
      <OfferPagePackageInclusionsList variant={bonusInclusions.length ? 'additional' : undefined}>
        {showReturnFlightsInclusion && rooms && <FlashHotelReturnFlightsInclusion rooms={rooms} size={size} />}
        {inclusions.map((inclusion) => <OfferInclusionItem key={inclusion.id} inclusion={inclusion} size={size} iconSize={iconSize} />)}
      </OfferPagePackageInclusionsList>
      <LoyaltyInclusions offer={offer} variant="offer-page" size={size} iconSize={iconSize} />
    </Group>
  </VerticalSpacer>
}

export default InclusionsSection
